<!--
 * @Author: zjw
 * @Date: 2021-05-18 11:40:40
 * @LastEditTime: 2022-09-19 16:29:28
 * @FilePath: \web-app\src\components\common\SidebarItem.vue
 * @Environment: Vue + Element
 * @Description: 侧边子菜单组件
-->
<template>
  <div class="sidebarItem">
    <!-- 只有一级子导航栏目 -->
    <el-menu-item v-if="hasOneShowingChild(menuList)" :index="menuList.url">
      <!-- class="iconfont icon" -->
      <i :class="menuList.icon" class="iconfont"></i>
      <span slot="title">{{ menuList.name }}</span>
    </el-menu-item>

    <!-- 当有多级子导航栏目 -->
    <el-submenu
      v-else
      :index="menuList.url"
      :key="menuList.url"
      class="el-submenu"
    >
      <!-- template标签是用来控制submenu的对应的那级的导航栏内容的显示 -->
      <template slot="title">
        <i :class="menuList.icon" class="iconfont"></i>
        <span class="sidename">{{ menuList.name }}</span>
      </template>
      <!-- 递归去遍历子级下面还有没子级 -->
      <sidebar-item
        v-for="(items, index) in menuList.menuChild"
        :key="index"
        :menuList="items"
      >
      </sidebar-item>
    </el-submenu>
  </div>
</template>
<script>
export default {
  name: "SidebarItem",
  props: {
    menuList: {
      //父组件传来的每个路由对象
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  methods: {
    hasOneShowingChild(menuList) {
      //判断当前的路由对象中是否有子级路由,并且子级路由的数量不能少于0个
      if (menuList.menuChild != null) {
        return false;
      }
      return true;
    },
  },
};
</script>
<style scoped>
/* element 导航菜单折叠动画，文字不隐藏 */
/*隐藏文字*/
.el-menu--collapse .el-submenu__title span {
  display: none;
}
/*隐藏 > */
.el-menu--collapse .el-submenu__title .el-submenu__icon-arrow {
  display: none;
}
/* 给每个侧边栏添加合适的间距 */
.sidename {
  padding-left: 10px;
}
/* 使用deep深度选择器修改样式 */
.el-submenu /deep/.el-submenu__icon-arrow {
  top: 55%;
  right: 15px;
}

.icon {
  margin-right: 6px;
}
/* 侧边栏耳机列表添加背景色以及hover效果 */
::v-deep .el-menu-item {
  background-color: rgba(250, 250, 250, 0) !important;
}
::v-deep .el-menu-item:hover {
  background-color: #001528 !important;
}
::v-deep .el-menu {
  background-color: #1f2d3d !important ;
}
::v-deep.el-menu-item span {
  margin-left: 5px;
}
</style>
